module.exports = __webpack_public_path__ + "img/yw_ydck.ffd0ca8c.svg";